import AmexGDAVenues from './AmexGDAVenues';

export default AmexGDAVenues;
